export default __webpack_public_path__ + "static/media/groups-icon-yellow.0161308e.svg";